export default {
    /**
     * @description 能不能吃项目配置
     */
    eatingConfig: {
        baseUrl: {
            // dev:'http://192.168.1.127:8081/app-yunejia',
            // dev: 'http://dev.gzmoninet.com/app-yunejia/',
            dev: "https://api.gzmoninet.com/app-yunejia/api/wxoa",
            pro: 'https://api.gzmoninet.com/app-yunejia/api/wxoa',
            getBanner: "https://api.gzmoninet.com/app-yunejia/api"
        }
    }
}